import React, { Fragment, useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import ContractService from "Services/http/endpoints/contract/ContractService";
import { contractColumn } from "Constants/TableColumns";
import { changeTableData } from "Stores/actions/ContractActions";
import { useTranslation } from "react-i18next";
import RemoteTable from "Components/RemoteTable/RemoteTable";

function TblContract() {
  const { t } = useTranslation();
  const { selectedProject, contractData, tableDataContract } = useSelector(
    (state) => ({
      selectedProject: state.project.selectedProject,
      contractData: state.contract.contractData,
      tableDataContract: state.contract.tableDataContract,
    })
  );
  const [dataContract, setDataContract] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          ProjectId: selectedProject.Id,
        };
        const response = await ContractService.GetAllContract(params);
        let updatedData = response.data.Value;
        const paymentsNew = updatedData.Payments.map((item, index) => {
          return {
            ...item,
            id: index,
            Type: item.TypePayment === 1 ? t("byCash") : t("byCheck"),
          };
        });
        updatedData.Payments = paymentsNew;
        setDataContract(updatedData);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, [selectedProject]);

  useEffect(() => {
    if (dataContract?.Payments) {
      const updatedData = tableDataContract.concat(dataContract.Payments);
      setData(updatedData);
    }
  }, [dataContract]);

  useEffect(() => {
    if (contractData) {
      const updateData = tableDataContract.concat(contractData);
      setData(updateData);
    }
  }, [contractData]);

  useEffect(() => {
    dispatch(changeTableData(data));
  }, [data]);

  return (
    <>
      <Fragment>
        <RemoteTable
          data={tableDataContract}
          columns={contractColumn}
          title={t("view_payments")}
          loading={loading}
          page={1}
          sizePerPage={100}
          showPagination={false}
          totalSize={tableDataContract.length}
        />
      </Fragment>
    </>
  );
}

export default TblContract;
